/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object } from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { createUrl } from 'utils/urlHelper';

import { EditProfile, ViewProfile } from 'components/Profile/Profile';
import { EditCompany, ViewCompany } from 'components/Company/Company';
import Portfolio from 'components/Portfolio/Portfolio';
import Payments from 'components/Payments/Payments';
import UpdatePhone from 'components/UpdatePhone/UpdatePhone';
import Inbox from 'components/Inbox/Inbox';
import JobList from 'components/JobList/JobList';
import JobEdit from 'components/JobEdit/JobEdit';
import JobView from 'components/JobView/JobView';
import JobSendOffer from 'components/JobSendOffer/JobSendOffer';

import styles from './account.scss';

/**
 * This is the Account component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Account extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: object.isRequired,
  };

  /**
   * Render Account.
   *
   * @return {Object}
   */
  render() {
    const { user } = this.props;

    return (
      <Switch>
        <Redirect exact from="/account" to={createUrl('talents')} />

        <Route exact path="/account/inbox/:discussionId?" component={Inbox} />

        <section className={styles.wrapper}>
          <div className={styles.content}>
            {/* NOTE: Move onboarding to Talents for talents? */}
            {/* {user.is_talent && (
              <Route exact path="/account" component={Dashboard} />
            )} */}

            <Route exact path="/account/profile" component={EditProfile} />

            {user.is_client && [
              <Route
                exact
                path="/account/company"
                component={EditCompany}
                key="company-edit"
              />,
              <Route
                strict
                path="/account/company/:companyId"
                component={ViewCompany}
                key="company-view"
              />,
            ]}

            {user.is_talent && [
              <Route
                exact
                path="/account/portfolio"
                component={Portfolio}
                key="portfolio"
              />,
              <Route
                strict
                path="/account/profile/:slug"
                component={ViewProfile}
                key="profile-view"
              />,
            ]}

            <Route exact path="/account/payments" component={Payments} />
            <Route exact path="/account/phone/update" component={UpdatePhone} />

            {user.is_client &&
              user.can_post_jobs && [
                <Route
                  exact
                  path="/account/jobs"
                  key="job-list"
                  component={JobList}
                />,
                <Route
                  exact
                  path="/account/jobs/edit/:jobId"
                  key="job-edit"
                  component={JobEdit}
                />,
                <Route
                  exact
                  path="/account/jobs/view/:jobId"
                  key="job-view"
                  component={JobView}
                />,
              ]}

            {user.is_client && (
              <Route
                exact
                path="/account/jobs/offer/:discussionId"
                component={JobSendOffer}
              />
            )}
          </div>
        </section>
      </Switch>
    );
  }
}

export default connect(({ user }) => ({ user }))(Account);
